<template>
  <div>
    
    <v-btn v-if="!showList" color="success" class="mx-0" @click="showArchiveList(1)">
      <v-icon>rate_review</v-icon> See Archive List
    </v-btn>

    <div v-if="showList">
      <v-card-title>      
        <h2>Archive List</h2>      
        <v-spacer></v-spacer>
        <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>

      <span style="display:none;">{{serial=serialNumber}}</span>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :pagination.sync="pagination"
        :total-items="totalDesserts"
        :loading="loading"
        class="elevation-4"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{serial++}}</td>
          <td class="text-xs-left">{{ props.item.eco_code }}</td>
          <td class="text-xs-left">{{ props.item.account_name }}</td>
          <td class="text-xs-left">{{ props.item.unit_name }}</td>        
          <td class="text-xs-left">{{ props.item.gob_amount }}</td>
          <td class="text-xs-left">{{ props.item.ida_amount }}</td>
          <td class="text-xs-left">{{ props.item.total }}</td>
          <td class="text-xs-left">{{ props.item.quantity }}</td>
          <td style="color:green; font-weight:bold;">Revised</td> 
          <td class="text-xs-left">{{ props.item.modified_date }}</td>
          <td class="text-xs-left">
            <span v-if="props.item.is_active" class="active">Yes</span>
            <span v-else class="in-active">No</span>
          </td>
          
        </template>
      </v-data-table>
    </div>
  </div>
</template>


<script>
const commonService = require("../../../../services/common.service");
import Axios from "axios";

export default {

  data: () => ({
    showList: false,
    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      { text: "Economic Code", align: "left", sortable: true, value: "eco_code" },
      { text: "Economic Code Name", align: "left", sortable: true, value: "account_name" },
      { text: "Measurement Unit", align: "left", sortable: true, value: "unit_name" },
      { text: "GoB Amount", align: "left", sortable: true, value: "gob_amount" },
      { text: "IDA Amount", align: "left", sortable: true, value: "ida_amount" },
      { text: "Total Amount", align: "left", sortable: true, value: "total" },
      { text: "Quantity", align: "left", sortable: true, value: "quantity" },
      { text: "Status", align: "center", value: "" },
      { text: "Revised Date", align: "left", sortable: true, value: "modified_date" },
      { text: "Active", align: "left", sortable: true, value: "is_active" },
     
      ],
    /*------------- /Datatable ---------------*/
  }),

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.showArchiveList(1);
        /*this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });*/
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {

    showArchiveList(action){
      //console.log('action', action);
      this.showList = false
      if(action == 1)
      {
          this.showList = true
          this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });    
      }
    },

    getDataFromApi() {

      let projectId = sessionStorage.getItem("proId")
      if(!projectId)
      {
        this.$router.push('/financial/yearly-project-budget');
      }

      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search),
          (query_Data.tbl = 'archive');
          (query_Data.projectId = sessionStorage.getItem("proId"));

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "yearly-pro-budget-detail-list-archive")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;
            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },
  
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/yearly_project_budget/yearly_pro_bud_details/yearlyDetailArchive.vue